<img [src]="'assets/images/file-icons/' + fileIcon + '.png'" />
